import {mapActions} from 'vuex';

import LineChart from './../Charts/LineChart';
import BarChart from './../Charts/BarChart';

import * as PATIENT from '@/store/constants/patient';
import * as APPOINTMENT from '@/store/constants/appointment';
import * as MEDICINE from '@/store/constants/medicine';

import moment from 'moment';

export default {
  data() {
    return {
      patients: {
        latest: [],
        fields: [
          'first_name',
          'last_name',
          {key: 'created_at', label: 'Created'},
        ]
      },

      appointments: {
        latest: [],
        fields: [
          'patient_name',
          {key: 'created_at', label: 'Created'},
        ]
      },

      trends: {
        appointment: [],
        patient: []
      },

      kpi: {
        medicine: [],
        patient: [],
        appointment: []
      }
    };
  },
  components: {
    LineChart,
    BarChart
  },

  computed: {
    medicineKpi() {
      return this.kpi.medicine[0] || {};
    },

    patientKpi() {
      return this.kpi.patient[0] || {};
    },

    appointmentKpi() {
      return this.kpi.appointment[0] || {};
    }
  },

  methods: {
    ...mapActions({
      getPatients: PATIENT.ACTION_LIST_PATIENTS,
      getPatientTrends: PATIENT.ACTION_TREND,
      getAppointments: APPOINTMENT.ACTION_LIST_APPOINTMENTS,
      getAppointmentTrends: APPOINTMENT.ACTION_TREND,
      getMedicineKpi: MEDICINE.ACTION_AGGREGATE,
      getAppointmentKpi: APPOINTMENT.ACTION_AGGREGATE,
      getPatientKpi: PATIENT.ACTION_AGGREGATE
    }),

    lastAppointments() {
      this.getAppointments({
        order_by: [`appointment_date,desc`],
        per_page: 5
      }).then(res => {
        this.appointments.latest = res.data.data;
      })
    },

    latestPatients() {
      this.getPatients({
        order_by: [`created_at,desc`],
        per_page: 5
      }).then(res => {
        this.patients.latest = res.data.data;
      })
    },

    handleKpis() {
      const payload = {
        type: 'count',
        date_range_start: moment().subtract(2, 'weeks').format('Y-MM-DD'),
        date_range_end: moment().format('Y-MM-DD')
      };

      this.getMedicineKpi(payload).then((res) => this.kpi = {...this.kpi, ...{medicine: this.compareKpi(res.data)}});
      this.getAppointmentKpi(payload).then((res) => this.kpi = {...this.kpi, ...{appointment: this.compareKpi(res.data)}});
      this.getPatientKpi(payload).then((res) => this.kpi = {...this.kpi, ...{patient: this.compareKpi(res.data)}});
    },

    /**
     * @param {Array} data
     * @return {Array}
     */
    compareKpi(data) {
      let kpi = [];

      data.map((i, index) => {
        const previousRecord = data[index + 1] || null;
        let percentage = 0;
        let diff = 0;

        if (previousRecord) {
          diff = previousRecord.count - i.count;
          percentage = diff / previousRecord.count * 100;
        }

        const up = (percentage >= 0 && diff <= 0);
        kpi.push({
          ...i, ...{
            arrow: up ? 'dripicons-arrow-thin-up text-success' : 'dripicons-arrow-thin-down text-danger',
            class: up ? 'text-success' : 'text-danger',
            percentage: Math.abs(percentage)
          }
        });
      });

      console.log(kpi);
      return kpi;
    },

    /**
     * Get trend lines filtered by date.
     *
     * @returns {{start_date: string, end_date: string}}
     */
    getTrendLineFilterDates() {
      return {
        start_date: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD')
      };
    },

    /**
     * Initialize trend lines.
     */
    initializeTrendLines() {
      this.getPatientTrends(this.getTrendLineFilterDates()).then(res => {
        this.trends.patient = res.data;
      });

      this.getAppointmentTrends(this.getTrendLineFilterDates()).then(res => {
        this.trends.appointment = res.data;
      });
    }
  },

  created() {
    this.latestPatients();
    this.lastAppointments();
    this.initializeTrendLines();
    this.handleKpis();
  }
}



// WEBPACK FOOTER //
// ./src/views/Dashboard/js/dashboard.js